import Scale from "./scale";

export default class ScaleMobile extends Scale {
  preScale() {
    // $(".arena-workspace").css
    //   height: window.innerHeight - 154 - 65 #hardcoded values to fix issue in fb browser
    return super.preScale();
  }
}

window.SectionScaleMobile = ScaleMobile;
